import { render } from "./MemberRegistrationReview.vue?vue&type=template&id=b4ee6136&scoped=true"
import script from "./MemberRegistrationReview.vue?vue&type=script&lang=js"
export * from "./MemberRegistrationReview.vue?vue&type=script&lang=js"

import "./MemberRegistrationReview.vue?vue&type=style&index=0&id=b4ee6136&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4ee6136"],['__file',"src/views/MemberRegistrationReview/MemberRegistrationReview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b4ee6136"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b4ee6136', __exports__)) {
    api.reload('b4ee6136', __exports__)
  }
  
  module.hot.accept("./MemberRegistrationReview.vue?vue&type=template&id=b4ee6136&scoped=true", () => {
    api.rerender('b4ee6136', render)
  })

}


export default __exports__